import { Controller } from "@hotwired/stimulus"

// makes a whole row select its checkbox, so there is one big target to hit on a phone.
// anything in the row that already responds to a click is left to do its own thing.
export default class extends Controller {
  static targets = ["checkbox"]

  toggle(event) {
    if (!this.hasCheckboxTarget) return

    const checkbox = this.checkboxTarget
    if (checkbox.disabled) return
    if (event.target.closest("a, button, input, select, textarea")) return

    // a label naming a control already toggles it; a decorative one, such as the entry fee's, does not
    const label = event.target.closest("label")
    if (label && (label.htmlFor || label.querySelector("input, select, textarea"))) return

    checkbox.checked = !checkbox.checked
    checkbox.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
